import { Opportunity } from "@entities";
import type { ActiveFilter } from "@shared/frontend/hyper-table/filter-types";
import { repo } from "remult";

const OPPORTUNITIES_TABLE_ID = "opportunities-table";

export function opportunitiesTableFiltersStorageKey() {
  return `hyper_table_${repo(Opportunity).metadata.key}_${OPPORTUNITIES_TABLE_ID}_filters`;
}

export function applyPartnerOrgFilterToOpportunitiesTable(
  partnerOrganizationId: string,
  partnerOrganizationName: string,
) {
  const key = opportunitiesTableFiltersStorageKey();
  const stored = JSON.parse(
    sessionStorage.getItem(key) ?? "[]",
  ) as ActiveFilter<Opportunity>[];
  const next = stored.filter((f) => f.id !== "partnerOrganizationId");
  next.push({
    id: "partnerOrganizationId",
    value: Opportunity.hyperFilter({
      partnerOrganizationId,
    }),
    meta: {
      text: partnerOrganizationName,
      selectedOrgs: [{ id: partnerOrganizationId, name: partnerOrganizationName }],
    },
    saveInSessionStorage: true,
  });
  sessionStorage.setItem(key, JSON.stringify(next));
}
